import Backbone from 'backbone'
import _ from 'lodash'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME, SNAPSHOT } = Dataset
import unwrapModel from 'scoreboard/components/unwrap-model'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

// functionality shared by dataset-series-creator and dataset-series-editor
var DatasetSeriesForm = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	/**
	 * Renders the calendarFieldIdentifier dropdown which specifies the calendar field
	 * used to break the datasets data into periods
	 */
	renderCalendarField: function() {
		let fields = []
		let selectedId = this.model.idsToFieldIdentifier({
			fieldId: _.get(this.options, 'datasetSeries.calendarFieldId'),
			visibleLinkedFieldId: _.get(this.options, 'datasetSeries.calendarVisibleLinkedFieldId')
		})
		if (this.isNoneAggregation()) {
			selectedId = SNAPSHOT
		} else {
			fields = _.filter(this.model.combinedFields, f =>
				f.dataType === DATE)
		}
		// #28872 If a default app calendar field has been set, then it will be
		// used as the default calendar field ID
		if (!_.isNil(this.options.calendarFieldIdentifier) && this.options
			.calendarFieldIdentifier != ALL_TIME) {
			selectedId = this.options.calendarFieldIdentifier
		}
		let allowedVisibleLinkedFields = _.filter(this.model.get('visibleLinkedFields'), vlf => {
			let field = this.model.combinedFieldsById[vlf.fieldId]
			return _.get(field, 'dataType') === DATE
		})

		renderFieldDropdown({
			el: this.$('[name=calendarFieldIdentifier]'),
			dataset: this.model,
			allowedFieldIds: _.map(fields, 'id'),
			allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFields, 'id'),
			includeSnapshot: true,
			selectedId
		})
	},

	/**
	 * Returns whether the field used to create the metric has a none
	 * aggregation type
	 */
	isNoneAggregation: function() {
		let columnFieldId =
			this.$('[name=columnFieldId]').val() ||
			_.get(this.options, 'datasetSeries.columnFieldId') ||
			this.options.columnFieldId
		let columnField = this.model.combinedFieldsById[columnFieldId]
		return _.get(unwrapModel(columnField), 'aggregationType') === 'none'
	}

})

export default DatasetSeriesForm

DatasetSeriesForm.__filename__ = 'datasets/dataset-series-form.js'
